import React from 'react';
import {
    Row,
    Col,
    Button,
    message,
    Input,
    Typography,
    Divider,
    Form
} from 'antd';
// import {
//     PrinterOutlined
// } from '@ant-design/icons';
import { useMutation } from '@tanstack/react-query';
import axios from '../../../config/axios';

function FormUser() {
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const { mutate, isLoading } = useMutation({
        mutationFn: (data) => {
            axios
                .post(`/auth/changepassword`, data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => {
                            localStorage.clear();
                            window.location.replace('/');
                        }
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    const onFinish = (values) => {
        if (values.password_new !== values.confirm_password) {
            messageApi.open({
                type: 'error',
                content: 'ยืนยันรหัส ไม่ถูกต้อง',
            });
        } else {    
            mutate(values);
        }
    }

    return (
        <div>
            {contextHolder}
            <Typography.Title level={5}>
                แก้ไขรหัสผ่าน
            </Typography.Title>
            <Divider />
            <Row>
                <Col xs={24} md={16}>
                    <Form
                        form={form}
                        layout="vertical"
                        name='formChangePassword'
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="password_old"
                            label="รหัสเก่า"
                            rules={[
                                {
                                    required: true,
                                    message: 'กรุณากรอกข้อมูล',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item
                            name="password_new"
                            label="รหัสใหม่"
                            rules={[
                                {
                                    required: true,
                                    message: 'กรุณากรอกข้อมูล',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item
                            name="confirm_password"
                            label="ยืนยันรหัส"
                            rules={[
                                {
                                    required: true,
                                    message: 'กรุณากรอกข้อมูล',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Row justify="end">
                            <Form.Item >
                                <Button type="primary" htmlType="submit" disabled={isLoading}>
                                    บันทึก
                                </Button>
                            </Form.Item>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default FormUser